"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("g", {
    clipPath: "url(#prefix__clip0_1185:10806)"
  }, __jsx("path", {
    d: "M0 24l1.695-6.16a11.823 11.823 0 01-1.594-5.947C.1 5.333 5.464.001 12.05.001c1.569 0 3.123.308 4.573.906a11.956 11.956 0 013.878 2.58 11.855 11.855 0 013.5 8.415c-.004 6.56-5.365 11.892-11.952 11.892h-.007c-1.994 0-3.958-.498-5.71-1.448L0 24zm6.629-3.807l.362.215a9.957 9.957 0 005.055 1.378h.004c5.475 0 9.93-4.435 9.933-9.885a9.866 9.866 0 00-2.907-6.993 9.955 9.955 0 00-7.022-2.899c-5.478 0-9.933 4.434-9.936 9.884a9.823 9.823 0 001.519 5.26l.236.374-1.004 3.65 3.76-.984z",
    fill: "#fff"
  }), __jsx("path", {
    d: "M.416 23.587l1.636-5.95a11.422 11.422 0 01-1.54-5.744C.515 5.562 5.69.413 12.05.413c1.515 0 3.016.298 4.416.876a11.54 11.54 0 013.743 2.49 11.482 11.482 0 012.5 3.729c.58 1.394.877 2.888.877 4.397 0 6.331-5.178 11.48-11.536 11.48h-.005c-1.926 0-3.821-.48-5.513-1.396L.416 23.587z",
    fill: "#20B038"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.064 6.92c-.223-.494-.458-.504-.671-.513C8.22 6.4 8.019 6.4 7.82 6.4a1.101 1.101 0 00-.796.372c-.274.298-1.046 1.017-1.046 2.48 0 1.462 1.07 2.875 1.22 3.074.148.198 2.065 3.295 5.099 4.486 2.52.99 3.036.794 3.583.742.547-.052 1.766-.72 2.015-1.413.249-.695.25-1.289.172-1.413-.077-.125-.273-.199-.573-.347-.3-.149-1.766-.868-2.04-.967-.273-.099-.473-.149-.672.149-.199.298-.77.966-.945 1.165-.174.198-.348.223-.647.074-.298-.149-1.26-.462-2.401-1.475-.888-.788-1.487-1.76-1.662-2.058-.175-.298-.018-.457.131-.607.134-.133.299-.347.448-.52.15-.174.2-.298.298-.496.1-.198.05-.372-.024-.52-.075-.15-.65-1.618-.916-2.205z",
    fill: "#fff"
  })), __jsx("defs", null, __jsx("linearGradient", {
    id: "prefix__paint0_linear_1185:10806",
    x1: 12,
    y1: 23.585,
    x2: 12,
    y2: 0.416,
    gradientUnits: "userSpaceOnUse"
  }, __jsx("stop", {
    stopColor: "#20B038"
  }), __jsx("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), __jsx("clipPath", {
    id: "prefix__clip0_1185:10806"
  }, __jsx("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
}
var _default = exports.default = SvgComponent;